import { Link } from "react-router-dom";
import brokerageLogo from "@/assets/align-right-realty-logo.webp";

const Footer = () => {
  return (
    <footer className="bg-brand-charcoal-section text-brand-ivory">
      <div className="container mx-auto max-w-[1400px] px-6 py-20">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div className="md:col-span-2">
            <div className="flex items-center gap-4 mb-6">
              <div className="bg-brand-ivory rounded-sm p-3">
                <img
                  src={brokerageLogo}
                  alt="Align Right Realty - Homekey"
                  width={200}
                  height={200}
                  className="h-24 w-auto"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-col leading-none">
              <span className="font-serif text-2xl font-medium tracking-tight text-brand-ivory">
                John Mastroianni
              </span>
              <span className="text-[10px] tracking-[0.3em] uppercase mt-2 text-primary font-semibold">
                Align Right Realty - Homekey
              </span>
              </div>
            </div>
            <p className="text-brand-ivory/70 leading-relaxed max-w-md font-light">
              Four decades of trusted representation for buyers and sellers across
              Mercer, Middlesex, Monmouth and Ocean counties. Experience that
              quietly outperforms.
            </p>
          </div>

          <div>
            <h4 className="eyebrow-sm mb-5">
              Navigate
            </h4>
            <ul className="space-y-3 text-sm font-light">
              {[
                ["Home", "/"],
                ["About", "/about"],
                ["Buy", "/buy"],
                ["Sell", "/sell"],
                ["For Sale By Owner", "/for-sale-by-owner"],
                ["Expired Listings", "/expired-listings"],
                ["Free Books", "/#free-books"],
                ["Buyer's Guide", "/buyer-guide"],
                ["Seller's Guide", "/seller-guide"],
                ["Financial", "/financial"],
                ["Blog", "/blog"],
                ["Explore NJ", "/explore-nj"],
                ["Contact", "/contact"],
              ].map(([label, href]) => (
                <li key={href}>
                  <Link
                    to={href}
                    className="text-brand-ivory/70 hover:text-primary transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>

            <h4 className="eyebrow-sm mt-8 mb-5">
              Property Search
            </h4>
            <ul className="space-y-3 text-sm font-light">
              {[
                ["Search Homes", "/search"],
                ["Advanced Search", "/search"],
                ["Featured Listings", "/listings"],
              ].map(([label, href], i) => (
                <li key={`${href}-${i}`}>
                  <Link
                    to={href}
                    className="text-brand-ivory/70 hover:text-primary transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="eyebrow-sm mb-5">
              Office
            </h4>
            <ul className="space-y-4 text-sm font-light text-brand-ivory/70">
              <li>
                <span className="block text-brand-ivory font-normal">Home Office</span>
                Align Right Realty - Homekey<br />
                110 Aunt Molly Road<br />
                Hopewell, NJ 08525
              </li>
              <li>
                <span className="block text-brand-ivory font-normal">Broker Office</span>
                Align Right Realty - Homekey<br />
                296 Summerhill Road<br />
                Spotswood, NJ 08884
              </li>
              <li>
                <a href="tel:+16093062926" className="hover:text-primary transition-colors">
                  (609) 306-2926
                </a>
              </li>
              <li>
                <a
                  href="mailto:jmsellsnj@gmail.com"
                  className="hover:text-primary transition-colors break-all"
                >
                  jmsellsnj@gmail.com
                </a>
              </li>
              <li className="pt-2 text-xs tracking-widest uppercase text-brand-ivory/70">
                NJ Licensed Realtor®
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-brand-ivory/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-brand-ivory/70 tracking-wider">
          <div className="text-center md:text-left space-y-1">
            <p>© {new Date().getFullYear()} John Mastroianni · Align Right Realty - Homekey. All rights reserved.</p>
            <p>AIIM LLC d/b/a Align Right Realty - Homekey</p>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            <Link to="/privacy-policy" className="hover:text-primary transition-colors uppercase tracking-[0.25em]">
              Privacy Policy
            </Link>
            <Link to="/terms-and-conditions" className="hover:text-primary transition-colors uppercase tracking-[0.25em]">
              Terms &amp; Conditions
            </Link>
            <p className="uppercase tracking-[0.25em]">
              Equal Housing Opportunity
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
